import { render } from "./PrivacyPolicyView.vue?vue&type=template&id=46b7c45c&scoped=true"
const script = {}

import "./PrivacyPolicyView.vue?vue&type=style&index=0&id=46b7c45c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.16_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b7c45c"]])

export default __exports__